import React, { useState, useContext, useEffect } from 'react';
import ModuleHeaderLayout from '../../components/Common/Layouts/ModuleHeaderLayout';
import { GlobalContext } from '../../providers/GlobalProvider';
import Tariff from 'components/TariffChecker/Tariff';
import FullRecord from 'pages/screening/FullRecord';
import { Modal } from '@mui/material';
import PaymentsAPI from 'api/PaymentsAPI';


const TariffChecker: React.FC = () => {
  const [ showFullRecord, setShowFullRecord ] = useState({
    show: false,
    record: {},
  });
  const [ page, setPage ] = useState(0);

  // stripe
  const [ userHasCommoditySearch, setUserHasCommoditySearch ] = useState(false);
  const [ matchedTeamWithStripe, setMatchedTeamWithStripe ] =
    useState<string>('');
  const [ activeCommoditySub, setActiveCommoditySub ] = useState(false);
  const [ screeningCus, setScreeningCus ] = useState({ isLoading: true, data: '' });

  const { cur_user } = useContext(GlobalContext);

  const [ tariffInputs, setTariffInputs ] = useState<any>(
    {
      htsCode: '',
      originCountry: '',
    },
  );


  const checkLicense = () => {
    if (
      cur_user.selected_team?.attributes?.tier?.includes('enterprise') ||
      cur_user.selected_team?.attributes?.tier?.includes('pro')
    ) {
      setUserHasCommoditySearch(true);
    }
    if (cur_user.stripe_cus_info) {
      cur_user.stripe_cus_info.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setMatchedTeamWithStripe(cus.id);
          cus.subscriptions.data.map((sub: any) => {
            if (
              sub.metadata.moduleName === 'BITE Pro' ||
              sub.metadata.moduleName === 'BITE Enterprise'
            ) {
              setActiveCommoditySub(true);
            }
          });
        }
      });
    }
  };


  const getCusFromEmail = async() => {
    const res = await PaymentsAPI.getCustomerByEmail(
      cur_user.selected_team.attributes.team_admin[0]
    );
    if (res?.success) {
      res?.result?.data?.map((cus: any) => {
        if (cus.name === cur_user.selected_team.name) {
          setScreeningCus({ isLoading: false, data: cus });
        }
      });
    }
  };

  useEffect(() => {
    getCusFromEmail();
  }, []);

  useEffect(() => {
    checkLicense();
  }, [ activeCommoditySub ]);

  const helpContent = (
    <p className='module-header-tooltip-text'>
      Check for tariffs that may apply to your products and recieve the total calculation that you will need to account for in a transaction.
    </p>
  );

  return (
    <ModuleHeaderLayout title='Tariff Checker' helpContent={helpContent}>
      <Tariff
        screeningCus={screeningCus}
        activeSub={activeCommoditySub}
        userHasCommoditySearch={userHasCommoditySearch}
        matchedTeamWithStripe={matchedTeamWithStripe}
        cur_user={cur_user}
        setShowFullRecord={setShowFullRecord}
        inputs={tariffInputs}
        setInputs={setTariffInputs}
        page={page}
        setPage={setPage}
      />
      <Modal
        open={showFullRecord.show}
        onClose={() => setShowFullRecord({ show: false, record: {} })}
      >
        <FullRecord
          setShowFullRecord={setShowFullRecord}
          showFullRecord={showFullRecord}
        />
      </Modal>
    </ModuleHeaderLayout>
  );
};

export default TariffChecker;
